import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLearnRhythm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.6,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 12,
			cy: 9.5,
			rx: 8,
			ry: 3
		}),
		/* @__PURE__ */ _jsx("path", { d: "M4 9.5v7c0 1.7 3.6 3 8 3s8-1.3 8-3v-7M8 12.3v6.6M16 12.3v6.6" }),
		/* @__PURE__ */ _jsx("path", { d: "M5.5 3l6 5.5M18.5 3l-6 5.5" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5.2,
			cy: 2.7,
			r: 1.1,
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 18.8,
			cy: 2.7,
			r: 1.1,
			fill: "currentColor",
			stroke: "none"
		})
	]
});
export default SvgLearnRhythm;
